import React from 'react';
import { Paper, Typography } from '@mui/material';

export default function MetricCard({ label, value, hint }) {
  return (
    <Paper sx={{ p: 2.5, minWidth: 0 }}>
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
      <Typography
        variant="h2"
        component="p"
        sx={{ mt: 1, fontVariantNumeric: 'tabular-nums' }}
      >
        {value}
      </Typography>
      {hint ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
          {hint}
        </Typography>
      ) : null}
    </Paper>
  );
}
